<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      stripe: "",
      checkout: "",
      checkoutDisplayed: false,
      clientSecret: "",
      num: 1,
      agreementDate: "",
      agreementDateWarn: false,
      agreementName: "",
      agreementNameWarn: false,
      purchasingEntity: "",
      promisePurchaser: null,
      promiseLegal: null,
      promiseOther: null,
      checked: false,
      apartment: "Apartments",
      townhouse: "Townhouses",
      house: "House",
      houseLand: "House & Land",
      landOnly: "Land",
      reservationFormRules: {
        allPurchaser: {
          0: {
            title: [
              { required: true, message: "Please enter title", trigger: "none" }
            ],

            firstName: [
              {
                required: true,
                message: "Please enter first name",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],

            surName: [
              {
                required: true,
                message: "Please enter surname",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],
            address: [
              {
                required: true,
                message: "Please enter address",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],
            suburb: [
              {
                required: true,
                message: "Please enter suburb",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],

            state: [
              { required: true, message: "Please enter state", trigger: "none" }
            ],

            postcode: [
              {
                required: true,
                message: "Please enter postcode",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],

            email: [
              {
                required: true,
                message: "Please enter email",
                trigger: "none"
              },
              {
                type: "email",
                message: "Please enter a valid email",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ]
          },
          1: {
            title: [
              { required: true, message: "Please enter title", trigger: "none" }
            ],

            firstName: [
              {
                required: true,
                message: "Please enter first name",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],

            surName: [
              {
                required: true,
                message: "Please enter surname",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],
            address: [
              {
                required: true,
                message: "Please enter address",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],
            suburb: [
              {
                required: true,
                message: "Please enter suburb",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],

            state: [
              { required: true, message: "Please enter state", trigger: "none" }
            ],

            postcode: [
              {
                required: true,
                message: "Please enter postcode",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],

            email: [
              {
                required: true,
                message: "Please enter email",
                trigger: "none"
              },
              {
                type: "email",
                message: "Please enter a valid email",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ]
          }
        },
        payment: {
          offerAmount: [
            { required: false, trigger: 'blur' },
            { type: 'number', message: 'Offer amount must be a number', trigger: 'change' },
            { validator: this.validateOfferAmount, trigger: "blur" }
          ]
        }
      },

      reservationForm: {
        cashDeposit: false,
        allPurchaser: [
          {
            purchaserId: 1,
            title: "",
            titleWarn: false,
            open: false,
            state: "",
            stateWarn: false,
            firstName: "",
            fristWarn: false,
            middleName: "",
            midWarn: false,
            surName: "",
            surWarn: false,
            address: "",
            addressWarn: false,
            suburb: "",
            suburbWarn: false,
            email: "",
            postcode: "",
            postcodeWarn: false,
            openState: false,
            emailWarn: false,
            mobile: "",
            mobileWarn: false,
            phone: "",
            phoneWarn: false
          }
        ],
        legal: {
          companyName: "",
          companyWarn: false,
          person: "",
          firstName: "",
          lastName: "",
          personWarn: false,
          address: "",
          addressWarn: false,
          suburb: "",
          suburbWarn: false,
          state: "",
          stateWarn: false,
          postcode: "",
          postcodeWarn: false,
          openState: false,
          email: "",
          emailWarn: false,
          mobile: "",
          mobileWarn: false,
          phone: "",
          phoneWarn: false
        },
        purchaser: {
          title: "",
          firstName: "",
          surname: "",
          address: "",
          suburb: "",
          state: "",
          postcode: "",
          phone: "",
          email: "",
          purchasingEntity: ""
        },
        conveyancerOrSolicitor: {
          isUnifiProvided: false,
          companyName: "",
          contactPerson: "",
          address: "",
          suburb: "",
          state: "",
          postcode: "",
          phone: "",
          email: ""
        },
        executed: {
          name: "",
          date: ""
        },
        agent: {
          companyName: "VARO Property",
          contactPerson: "Craig Chrystie",
          address: "123 Real St",
          suburb: "Sydney",
          state: "New South Wales",
          postcode: "2000",
          phoneNumber: "0412 345 678",
          email: "craig@varo.com",
          singleLineAddress: ""
        },
        payment: {
          offerAmount: "",
          cardName: "",
          cardNumber: "",
          exp: "",
          cvv: ""
        }
      },
      titles: [
        {
          id: 1,
          title: "Mr"
        },
        {
          id: 2,
          title: "Mrs"
        },
        {
          id: 3,
          title: "Miss"
        },
        {
          id: 4,
          title: "Ms"
        },
        {
          id: 5,
          title: "Dr"
        }
      ],
      listingStates: [
        // {
        //   id: 0,
        //   shortName: 'State',
        //   stateName: 'State'
        // },
        {
          id: 1,
          shortName: "ACT",
          stateName: "Australian Capital Territory"
        },
        {
          id: 2,
          shortName: "NSW",
          stateName: "New South Wales"
        },
        {
          id: 3,
          shortName: "NT",
          stateName: "Northern Territory"
        },
        {
          id: 4,
          shortName: "QLD",
          stateName: "Queensland"
        },
        {
          id: 5,
          shortName: "SA",
          stateName: "South Australia"
        },
        {
          id: 6,
          shortName: "TAS",
          stateName: "Tasmania"
        },
        {
          id: 7,
          shortName: "VIC",
          stateName: "Victoria"
        },
        {
          id: 8,
          shortName: "WA",
          stateName: "Western Australia"
        }
      ]
    };
  },
  props: {
    listingDetails: Object
  },
  created() {
    localStorage.removeItem("email");
    localStorage.removeItem("fname");
    localStorage.removeItem("sname");
    localStorage.removeItem("id");
  },
  components: {},
  methods: {
    ...mapActions("property", [
      "getPropertyDtl",
      "submitInfo",
      "getType",
      "getSignUrl"
    ]),
    ...mapActions("reserve", ["makeReservation"]),
    addAnotherPurchaser() {
      console.log("addAnotherPurchaser!");
      var that = this;
      // set the max number of purchasers
      if (that.num > 1) {
        return false;
      }
      that.num++;
      that.reservationForm.allPurchaser.push({
        purchaserId: that.num,
        title: "",
        open: false,
        state: "",
        openState: false,
        firstName: "",
        middleName: "",
        surName: "",
        address: "",
        suburb: "",
        mobile: "",
        email: "",
        postcode: ""
      });
    },
    callbackMakeReservation(resp) {
      console.log("callbackMakeReservation", resp);

      if (resp.data.code == 0) {
        this.clientSecret = resp.data.data.clientSecret;
        console.log("this.clientSecret", this.clientSecret);

        this.initialize();
        console.log("after initialize");
      } else {
      }
    },
    async initialize() {
      console.log("async initialize");
      console.log("checkout: ", this.checkout);
      this.checkout = await this.stripe.initEmbeddedCheckout({
        clientSecret: this.clientSecret
      });
      //this.checkout = checkout
      // Mount Checkout
      this.checkout.mount("#checkout");
      console.log("checkout adfter mounted: ", this.checkout);
      this.checkoutDisplayed = true;
    },
    conveyancerCheckboxToggle() {
      console.log(this.checked);
      if (!this.checked) {
        //populate the conveyancer fields, and set the fields to read only.
        (this.reservationForm.legal.companyName = "Elite Conveyancing"),
          (this.reservationForm.legal.person = "Maria Mignone"),
          (this.reservationForm.legal.firstName = "Maria"),
          (this.reservationForm.legal.lastName = "Mignone"),
          (this.reservationForm.legal.address = "78A Luhrs Road"),
          (this.reservationForm.legal.suburb = "Firle"),
          (this.reservationForm.legal.state = "South Australia"),
          (this.reservationForm.legal.postcode = "5070"),
          (this.reservationForm.legal.openState = false),
          (this.reservationForm.legal.email = "maria@eliteconveyancing.net.au"),
          (this.reservationForm.legal.mobile = "0452094296"),
          (this.reservationForm.legal.phone = "");
      } else {
        (this.reservationForm.legal.companyName = ""),
          (this.reservationForm.legal.firstName = ""),
          (this.reservationForm.legal.lastName = ""),
          (this.reservationForm.legal.person = this.reservationForm.legal.firstName + ' ' + this.reservationForm.legal.lastName),
          (this.reservationForm.legal.address = ""),
          (this.reservationForm.legal.suburb = ""),
          (this.reservationForm.legal.state = ""),
          (this.reservationForm.legal.postcode = ""),
          (this.reservationForm.legal.openState = false),
          (this.reservationForm.legal.email = ""),
          (this.reservationForm.legal.mobile = ""),
          (this.reservationForm.legal.phone = "");
      }
    },
    dividePersonName() {
      var fullName = this.reservationForm.legal.person;
      var nameParts = fullName.split(" ");
      this.reservationForm.legal.firstName = nameParts[0];
      this.reservationForm.legal.lastName =
        nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";
    },
    submitReservation() {
      var that = this;
      //validation of Select Now form
      let passed = false;
      this.$refs.reservationForm.validate(valid => {
        if (valid) {
          passed = true;
        } else {
          that.$box.alert("", "Please fill the mandatory fields", "error");
          passed = false;
        }
      });
      if (!passed) {
        return;
      }
      var ordersPurchaserVOList = [];
      this.reservationForm.allPurchaser.forEach(v => {
        console.log(v.mobile);
        ordersPurchaserVOList.push({
          address: v.address,
          email: v.email,
          firstName: v.firstName,
          middleName: v.middleName,
          gender: v.title,
          mobile: v.mobile,
          state: v.state,
          suburb: v.suburb,
          surName: v.surName,
          postCode: v.postcode
        });
      });
      var ordersPurchaserLegalVO = {
        address: that.reservationForm.legal.address,
        companyName: that.reservationForm.legal.companyName,
        contactPerson: that.checked ? (that.reservationForm.legal.firstName + ' ' + that.reservationForm.legal.lastName) : that.reservationForm.legal.person,
        email: that.reservationForm.legal.email,
        mobile: that.reservationForm.legal.mobile,
        phone: that.reservationForm.legal.phone,
        state: that.reservationForm.legal.state,
        suburb: that.reservationForm.legal.suburb,
        postCode: that.reservationForm.legal.postcode
      };
      let month = that.reservationForm.payment.exp.slice(0, 2);
      let year = that.reservationForm.payment.exp.slice(2, 4);
      let arr = [];
      if (that.reservationForm.payment.exp.indexOf("/") != -1) {
        arr = that.reservationForm.payment.exp.split("/");
        month = arr[0];
        year = arr[1];
      }
      var OrdersBookVO = {
        cashDeposit: that.reservationForm.cashDeposit,
        ordersPurchaserLegalVO: ordersPurchaserLegalVO,
        ordersPurchaserVOList: ordersPurchaserVOList,
        purchasingEntity:
          that.purchasingEntity.replace(/\s+/g, "") == ""
            ? ""
            : that.purchasingEntity,
        makeOfferAmount: that.reservationForm.payment.offerAmount,
        ordersType: that.$route.query.type == "1" ? "Make Offer" : "Select Now",
        propertyId: that.$route.query.pid,
        roomId: that.$route.query.rid,
        stripeSessionId: that.$route.query.session_id
      };

      if (this.$route.query.type == "1" || this.$route.query.session_id) {
        that.$box.loadings();
        that.submitInfo({
          params: OrdersBookVO,
          callback: that.submitCallback
        });
      } else if (this.$route.query.type == "2") {
        console.log("stripe id ", process.env.VUE_APP_STRIPE);
        console.log("OrdersBookVO ", OrdersBookVO);
        this.stripe = Stripe(process.env.VUE_APP_STRIPE);
        that.makeReservation({
          params: OrdersBookVO,
          callback: this.callbackMakeReservation
        });
      }
    },
    validateNotOnlySpaceInputs(rule, value, callback) {
      if (!value.trim()) {
        callback(new Error("Input cannot be only spaces"));
      } else {
        callback();
      }
    },
    validateOfferAmount(rule, value, callback) {
      if (this.$route.query.type == "1") {
        if (value === "" || value === undefined) {
          callback(new Error("Please enter an offer"));
        } else if (!value.toString().trim()) { // Convert to string to use trim() safely
          callback(new Error("Input cannot be only spaces"));
        } else if (!/^\d+(\.\d{1,2})?$/.test(value)) {
          callback(new Error("Please input a valid offer amount"));
        } else if (value > 999000000000) {
          callback(new Error('Offer amount cannot exceed 999 billion'));
        } else {
          callback();
        }
      } else if (value !== null && value !== undefined && value !== "") { // Validate if value is entered when not mandatory
        if (!/^\d+(\.\d{1,2})?$/.test(value)) {
          callback(new Error("Please input a valid offer amount"));
        } else if (value > 999000000000) {
          callback(new Error('Offer amount cannot exceed 999 billion'));
        } else {
          callback();
        }
      }
      else {
        callback(); // Not mandatory and no value entered, validation passes
      }
    },
    destroy() {
      console.log("destroy checkout", this.checkout);
      console.log("destroy checkoutDisplayed", this.checkoutDisplayed);
      if (this.checkout) {
        this.checkout.unmount();
        this.checkout.destroy();
      }
    },
    showReservationPayment() {
      console.log("reservationForm", this.reservationForm);
      //validation of Select Now form
      if (this.$route.query.type == "2") {
        let passed = false;
        this.$refs.reservationForm.validate(valid => {
          if (valid) {
            passed = true;
          } else {
            this.$box.alert("", "Please fill the mandatory fields", "error");
            passed = false;
          }
        });

        if (!passed) {
          return;
        }
      }

      console.log("stripe id ", process.env.VUE_APP_STRIPE);
      this.stripe = Stripe(process.env.VUE_APP_STRIPE);
      var stripeSessionVo = {
        pid: this.$route.query.pid,
        rid: this.$route.query.rid
      };
      this.makeReservation({
        params: stripeSessionVo,
        callback: this.callbackMakeReservation
      });
    },

    submitCallback(res) {
      var that = this;
      that.$box.loadings(2);
      if (res.data.code == 0) {
        //8848
        that.$router.push({ path: "/property/reserve/confirm" });
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 70020) {
        that
          .$confirm("Property has expired", "error", {
            distinguishCancelAndCLOse: true,
            confirmBUttonText: "Back to Home"
          })
          .then(() => {
            that.$router.replace("/");
          })
          .catch(action => {
            console.log(action);
          });
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    getOfferType() {
      let totalprice = this.listingDetails.price;
      let totalpriceMax = this.listingDetails.maxPrice;
      let type = "Make Offer";

      if (totalprice && totalpriceMax && totalprice == totalpriceMax) {
        type = "Select now"; //fixed price
      } else if (totalprice && totalpriceMax) {
        type = "Make Offer"; //ranged
      } else if (totalprice && totalpriceMax == null) {
        type = "Select now"; //fixed price
      } else if (totalprice == null && totalpriceMax == null) {
        type = "Make Offer"; //no price
      } else if (totalprice && totalpriceMax == 0) {
        type = "Select now"; //fixed price
      }
      return type;
    }
  },
  mounted() {
    this.reservationForm.agent.singleLineAddress =
      this.reservationForm.agent.address +
      ", " +
      this.reservationForm.agent.suburb +
      ", " +
      this.reservationForm.agent.state +
      " " +
      this.reservationForm.agent.postcode;
    this.conveyancerCheckboxToggle();
  },

  beforeUpdate() {
    console.log("beforeUpdate function params: ", this.$route.query);
    if (this.$route.query.session_id != null) {
      console.log("sessionid is : ", this.$route.query.session_id);
      this.submitReservation();
    }
  }
};
</script>

<template>
  <el-row>
    <el-col :span="24" style="padding: 10px;">
      <div
        style="border: 4px solid #cccccc; border-radius: 30px; padding: 20px;"
      >
      <el-row>
        <el-col :span="24">
          <span class="form-selection-title">Reservation Form</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 15px">
        <el-col :span="24" class="d-flex jc-center ac-center">
            <span class="text-dino text-w500 text-26 color-green"
            >{{ listingDetails.apt }} / {{ listingDetails.address }}</span>
        </el-col>
        <el-col :span="24" class="d-flex jc-center ac-center">
            <span class="text-dino text-w500 text-26 color-green"
            >{{ listingDetails.suburb }}</span>
        </el-col>
<!--        <el-col :span="24" class="d-flex jc-center ac-center">-->
<!--          <el-divider direction="horizontal" style="padding: 0 5px;"></el-divider>-->
<!--        </el-col>-->
        <el-col :span="24" class="d-flex jc-center ac-center">
          <span class="text-dino text-w400 text-22 color-green"
          >{{ listingDetails.state }} {{ listingDetails.postcode }}</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24" class="d-flex jc-center ac-center">
          <el-divider direction="horizontal" style="padding: 0 5px;"></el-divider>
        </el-col>
        <el-col
          v-if="this.getOfferType() == 'Select now'"
          :span="24"
          style="display: flex; justify-content: center"
        >
            <span class="listing-price-state" style="margin-top: 0">{{
                listingDetails.price != 0 ? "$" + listingDetails.price : ""
              }}</span>
        </el-col>
        <el-col
          v-else
          :span="24"
          style="display: flex; justify-content: center; align-items: center">
                <span class="listing-price-state" style="margin-top: 0">
                  {{
                    listingDetails.price != 0 ? "$" + listingDetails.price : ""
                  }}
                  {{
                    listingDetails.maxPrice != 0
                      ? " - $" + listingDetails.maxPrice
                      : ""
                  }}
                </span>
        </el-col>
        <el-col :span="24" style="display: flex; justify-content: center; align-items: center; margin-top: 10px">
          <span class="chip-gray">{{ listingDetails.proertyType }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col
          v-if="$route.query.type == '2'"
          :span="24"
          style="margin-top: 20px; line-height: 1.5"
        >
<!--          <el-row>-->
<!--            <el-col :span="24" class="d-flex jc-center">-->
<!--              <span class="text-24 text-w400 text-dino text-center">Congratulations on selecting your brand-new property!</span>-->
<!--            </el-col>-->
<!--            <el-col :span="24" class="d-flex jc-center">-->
<!--                    <span class="text-22 text-w400 text-dino text-center">Our online-->
<!--              reservation process is simple and will reserve this property</span>-->
<!--            </el-col>-->
<!--            <el-col :span="24" class="d-flex jc-center">-->
<!--                    <span class="text-22 text-w400 text-dino text-center">-->
<!--                      exclusively for you for the next 7 days.</span>-->
<!--            </el-col>-->
<!--          </el-row>-->
          <el-row style="margin-top: 20px">
            <el-col :span="24" class="d-flex jc-center">
                    <span class="text-18 text-w400 text-dino text-center">
                      1. Complete the online form with all details of the purchaser and
                      conveyancer or solicitor.
                    </span>
            </el-col>
            <el-col :span="24" class="d-flex jc-center">
                    <span class="text-18 text-w400 text-dino text-center">
                      Please complete all details carefully as
                      they will be used to prepare the contract of sale and enable
                    </span>
            </el-col>
            <el-col :span="24" class="d-flex jc-center">
                    <span class="text-18 text-w400 text-dino text-center">
                      the Agent to contact you to progress the sale.
                    </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="d-flex jc-center">
                    <span class="text-18 text-w400 text-dino text-center">
                      2. Click “Pay and Submit Reservation” to pay the $1,000
                      reservation fee securely online.
                    </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="d-flex jc-center">
                    <span class=" text-18 text-w400 text-dino text-center">
                      3. Once your reservation is received, the Agent will contact you
                      directly to prepare the contract of sale and take you through next
                      steps.
                    </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="d-flex jc-center">
                    <span class="text-18 text-w400 text-dino text-center">
                      4. Upon the expiry of the 7-day reservation period, your $1,000
                      reservation fee will be refunded to your original method of
                      payment.
                    </span>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      </div>
      <el-row>
        <el-col :span="24">
          <el-form
            ref="reservationForm"
            :model="reservationForm"
            :rules="reservationFormRules"
          >
            <el-row>
              <el-col :span="24" style="margin-top: 10px">
                <span class="title-reservation-section">Purchaser Details</span>
              </el-col>
              <div
                v-for="(purchaser, index) in reservationForm.allPurchaser"
                :key="index"
              >
                <el-row>
                  <el-col :span="24" style="margin-top: 10px">
                  <span class="title-purchaser-section"
                  >Purchaser #{{ purchaser.purchaserId }}</span
                  >
                  </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-top: 20px">
                  <el-col :span="6">
                    <el-form-item :prop="'allPurchaser.' + index + '.title'">
                      <el-select
                        v-model="purchaser.title"
                        placeholder="Title"
                        style="display: inline"
                      >
                        <el-option
                          v-for="t in titles"
                          :key="t.id"
                          :label="t.title"
                          :value="t.title"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="18">
                    <el-form-item :prop="'allPurchaser.' + index + '.firstName'">
                      <el-input
                        v-model="purchaser.firstName"
                        placeholder="First name"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item>
                      <el-input
                        v-model="purchaser.middleName"
                        placeholder="Middle names"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item :prop="'allPurchaser.' + index + '.surName'">
                      <el-input
                        v-model="purchaser.surName"
                        placeholder="Surname"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item :prop="'allPurchaser.' + index + '.address'">
                      <el-input
                        v-model="purchaser.address"
                        placeholder="Address"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item :prop="'allPurchaser.' + index + '.suburb'">
                      <el-input
                        v-model="purchaser.suburb"
                        placeholder="Suburb"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item :prop="'allPurchaser.' + index + '.state'">
                      <el-select
                        v-model="purchaser.state"
                        placeholder="State"
                        style="display: inline"
                      >
                        <el-option
                          v-for="state in listingStates"
                          :key="state.id"
                          :label="state.stateName"
                          :value="state.stateName"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item :prop="'allPurchaser.' + index + '.postcode'">
                      <el-input
                        v-model="purchaser.postcode"
                        placeholder="Postcode"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item>
                      <el-input
                        v-model="purchaser.mobile"
                        placeholder="Phone"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item :prop="'allPurchaser.' + index + '.email'">
                      <el-input
                        v-model="purchaser.email"
                        placeholder="Email"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-row>
            <el-row>
              <el-col :span="24" style="display: flex; justify-content: center">
                <el-form-item>
                  <el-button
                    style="justify-content: center; border-radius: 0; border-bottom: 1px solid #003333; padding-bottom: 2px; color: #003333"
                    type="text"
                    @click="addAnotherPurchaser"
                  >
                    Add another purchaser's details
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <el-input
                    v-model="purchasingEntity"
                    placeholder="Purchasing entity"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" style="margin-top: 8px">
              <span
                class="para-form-selection"
                style="font: 400 18px DINosaur-a, sans-serif;"
              >Only complete if you are purchasing outside of your personal
                name</span
              >
              </el-col>
            </el-row>
            <el-row v-if="$route.query.type == '1'">
              <el-col :span="24" style="margin-top: 20px">
                <span class="title-reservation-section">Make an Offer</span>
              </el-col>
            </el-row>
            <el-row v-if="$route.query.type == '1'">
              <el-col :span="24" style="margin-top: 8px">
                <el-form-item prop="payment.offerAmount">
                  <el-input
                    v-model="reservationForm.payment.offerAmount"
                    placeholder="Make an offer"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" style="margin-top: 20px">
              <span class="title-reservation-section"
              >Purchaser's Conveyancer/Solicitor</span
              >
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" style="margin-top: 18px">
                <el-form-item>
                  <el-checkbox
                    v-model="checked"
                    style="display: flex; align-items: flex-start; width: 100%; align-items: center"
                    @change="conveyancerCheckboxToggle"
                  >
                  <span class="color-green text-w400 text-dino text-18 text-wrap"
                  >Please check the box if you would like to nominate a different conveyancer or solicitor and complete the
                    fields below</span
                  >
                  </el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <el-input
                    v-model="reservationForm.legal.firstName"
                    placeholder="First Name"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <el-input
                    v-model="reservationForm.legal.lastName"
                    placeholder="Last Name"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <el-input
                    v-model="reservationForm.legal.address"
                    placeholder="Address"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <el-input
                    v-model="reservationForm.legal.suburb"
                    placeholder="Suburb"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <el-select
                    v-model="reservationForm.legal.state"
                    placeholder="State"
                    style="display: inline"
                  >
                    <el-option
                      v-for="state in listingStates"
                      :key="state.id"
                      :label="state.stateName"
                      :value="state.stateName"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <el-input
                    v-model="reservationForm.legal.postcode"
                    placeholder="Postcode"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <el-input
                    v-model="reservationForm.legal.phone"
                    placeholder="Landline"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <el-input
                    v-model="reservationForm.legal.mobile"
                    placeholder="Landline"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <el-input
                    v-model="reservationForm.legal.email"
                    placeholder="Email"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <el-input
                    v-model="reservationForm.legal.companyName"
                    placeholder="Email"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <el-checkbox
                    v-model="reservationForm.cashDeposit"
                    style="display: flex; align-items: flex-start; width: 100%; align-items: center">
                  <span class="color-green text-w400 text-dino text-18 text-wrap">Would you like information on a deposit bond to secure this property without a cash deposit?
                    <em>By ticking this box, you consent to your contact details being shared with our deposit bond partner, Downsizer.</em></span>
                  </el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <span class="title-reservation-section">Agent's Details</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" style="margin-top: 18px">
                <el-form-item>
                  <el-col
                    :span="10" class="agent-details"
                  >
                    <span>Company Name</span>
                  </el-col>
                  <el-col
                    :span="14" class="agent-details-right"
                  >
                    <span>{{ listingDetails.companyName }}</span>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item>
                  <el-col
                    :span="10" class="agent-details"
                  >
                    <span>Contact Person</span>
                  </el-col>
                  <el-col
                    :span="14" class="agent-details-right"
                  >
                <span
                >{{ listingDetails.agentFirstName1 }}
                  {{ listingDetails.agentLastName1 }}</span
                >
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item>
                  <el-col
                    :span="10" class="agent-details"
                  >
                    <span>Address</span>
                  </el-col>
                  <el-col
                    :span="14" class="agent-details-right"
                  >
                    <span>{{ listingDetails.companyAddress }}</span>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item>
                  <el-col
                    :span="10" class="agent-details"
                  >
                    <span>Phone Number</span>
                  </el-col>
                  <el-col
                    :span="14" class="agent-details-right"
                  >
                    <span>{{ reservationForm.agent.phoneNumber }}</span>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item>
                  <el-col
                    :span="10" class="agent-details"
                  >
                    <span>Email</span>
                  </el-col>
                  <el-col
                    :span="14"  class="agent-details-right"
                    style="word-wrap: break-word; word-break: break-word"
                  >
                    <span>{{ listingDetails.companyEmail }}</span>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="listingDetails.price != 0 && $route.query.type == '2'">
              <el-col id="checkout" ref="checkout" :span="24"> </el-col>
            </el-row>
            <el-row>
              <el-col
                :offset="4"
                :span="16"
                style="margin-top: 20px; display: flex; justify-content: center"
              >
                <el-button
                  v-if="$route.query.type == '1'"
                  class="btn-pay-submit"
                  @click="submitReservation"
                >
                  <span>Submit Offer</span>
                </el-button>
                <el-button
                  v-if="$route.query.type == '2' && !checkoutDisplayed"
                  class="btn-pay-submit"
                  @click="submitReservation"
                >
                  <span>Pay and Submit Reservation</span>
                </el-button>
              </el-col>
              <el-col :span="24" style="margin-top: 20px">
              <span v-if="$route.query.type == '2'" class="para-form-selection"
              >Congratulations on your property reservation. Your real estate
                agent will be in touch shortly.</span
              >
                <span v-if="$route.query.type == '1'" class="para-form-selection"
                >Congratulations. Your real estate agent will be in touch
                shortly.</span
                >
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<style scoped>
.form-selection-title {
  color: #003333;
  font: 600 34px/120% DINosaur-a, sans-serif;
  display: flex;
  justify-content: center;
}

.chip-gray {
  color: #003333;
  white-space: nowrap;
  justify-content: center;
  border-radius: 10px;
  background-color: #cccccc;
  padding: 5px 12px;
  font: 400 16px/125% DINosaur-a, sans-serif;
}

.listing-price-state {
  font-feature-settings: "clig" off, "liga" off;
  margin-top: 12px;
  font: 400 26px/118% DINosaur-a, sans-serif;
  color: #003333;
}

.address-text {
  font: 600 34px DINosaur-a, sans-serif;
  color: #003333;
  line-height: 117.647%;
}

.price-text {
  margin-top: 18px;
  font: 400 24px DINosaur-a, sans-serif;
  color: #003333;
}

.state-text {
  margin-top: 12px;
  font: 400 18px/111.111% DINosaur-a, sans-serif;
  color: #003333;
}

.para-form-selection {
  color: #003333;
  align-self: start;
  font: 400 18px DINosaur-a, sans-serif;
  display: flex;
}

.btn-pay-submit {
  display: flex;
  padding: 15px 42px;
  justify-content: center;
  align-items: center;
  border-top-right-radius: 20px;
  background: #003333;
  border: 4px solid #003333;
  color: #ffffff;
}

.title-reservation-section {
  color: #003333;
  font: 600 30px DINosaur-a, sans-serif;
}

.title-purchaser-section {
  color: #003333;
  font: 600 20px DINosaur-a, sans-serif;
}

.el-checkbox {
  .el-checkbox__label {
    font-size: 18px;
    color: #003333;
  }
}

.text-16 {
  font-size: 16px;
}
.text-18 {
  font-size: 18px;
}
.text-20 {
  font-size: 20px;
}
.text-22 {
  font-size: 22px;
}
.text-24 {
  font-size: 24px;
}
.text-26 {
  font-size: 26px;
}
.text-36 {
  font-size: 36px;
}
.text-40 {
  font-size: 40px;
}
.text-dino {
  font-family: DINosaur-a, sans-serif;
}
.text-w400 {
  font-weight: 400;
}
.text-w500 {
  font-weight: 500;
}
.text-w600 {
  font-weight: 600;
}
.text-w700 {
  font-weight: 700;
}
.color-green {
  color: #003333;
}
.color-white {
  color: #ffffff;
}
.color-gray {
  color: #cccccc;
}
.d-flex {
  display: flex;
}
.jc-center {
  justify-content: center;
}
.ac-center{
  align-content: center;
}
.el-divider--vertical {
  width: 4px;
  font-size: 40px;
}
.el-divider--horizontal {
  height: 2px;
  margin: 5px 0;
}
.el-divider {
  background-color: #003333;
}
.mlf-30 {
  margin: 0 30px;
}
.mlf-5 {
  margin: 0 5px;
}
.mb-0 {
  margin-bottom: 0;
}
.el-divider--vertical.mlf-5 {
  width: 2px;
  font-size: 20px;
}
.btn-add-purchaser {
  font-size: 20px;
  transition: font-size 0.3s ease-in-out;
}
.btn-add-purchaser:hover {
  font-size: 21px;
}
.text-center {
  text-align: center;
}
.text-wrap {
  white-space: normal;
  word-break: break-word;
}
.agent-details {
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
  font: 500 18px DINosaur-a, sans-serif;
  color: #003333;
}
.agent-details-right {
  font: 400 18px DINosaur-a, sans-serif;
  color: #003333;
}
</style>



// WEBPACK FOOTER //
// src/components/reservation/reservationFormSection.vue